import { envType } from '@atlassiansox/analytics-web-client';

export enum ENVIRONMENT {
  LOCAL = 'local',
  DEV = 'development',
  STAGING = 'staging',
  PROD = 'production',
}

export const ENV_TO_ANALYTICS_ENV_TYPE = {
  [ENVIRONMENT.LOCAL]: envType.LOCAL,
  [ENVIRONMENT.DEV]: envType.DEV,
  [ENVIRONMENT.STAGING]: envType.STAGING,
  [ENVIRONMENT.PROD]: envType.PROD,
};

export type PostOfficeEnv = 'test' | 'local' | 'dev' | 'staging' | 'production' | 'stg-fedm-east' | 'prod-fedm-east';

export const ENV_TO_POST_OFFICE_ENV = {
  [ENVIRONMENT.LOCAL]: 'local' as PostOfficeEnv,
  [ENVIRONMENT.DEV]: 'dev' as PostOfficeEnv,
  [ENVIRONMENT.STAGING]: 'staging' as PostOfficeEnv,
  [ENVIRONMENT.PROD]: 'production' as PostOfficeEnv,
};

export const getPostOfficeEnvironment = (): PostOfficeEnv => {
  const currentEnv = getEnvironment();
  return ENV_TO_POST_OFFICE_ENV[currentEnv as keyof typeof ENV_TO_POST_OFFICE_ENV] || 'local';
};

export const getEnvironment = (defaultEnv = ENVIRONMENT.LOCAL): string => {
  return process.env.NODE_ENV || defaultEnv;
};

export const getEnvironmentAsEnum = (defaultEnv = ENVIRONMENT.DEV): ENVIRONMENT => {
  return (process.env.NODE_ENV || defaultEnv) as ENVIRONMENT;
};

export const getAnalyticsEnvType = (): envType => {
  return ENV_TO_ANALYTICS_ENV_TYPE[getEnvironment() as keyof typeof ENV_TO_ANALYTICS_ENV_TYPE];
};
